module.exports = __webpack_public_path__ + "img/slider-arr-w-right.93c22eff.svg";